import { commonStoreShell, delegate } from '@/common/StoreShell';
import Vue from "vue";

/**
 * 预定义好的广播类型
 */
export enum BroadcastType {
    /**用户切换语言,无附加参数 */
    APP_LocaleChange
}

interface BroadcastState {
    notify: number
    name: string | number
    from: number | null
    params: any[],
}

class BroadcastStore extends commonStoreShell<BroadcastState> {
    public getters = {
        notify: () => this.state.notify
    }

    protected getStateInit(): BroadcastState {
        return {
            notify: 0,
            name: 'anonymous',
            from: null,
            params: [],
        };
    }

    public send(name: string | number, from: number | null, ...params: any[]) {
        this.state.notify++;
        this.state.name = name;
        this.state.from = from;
        this.state.params = params;
    }

    public sendByName(name: string | number, ...params) {
        this.send(name, null, ...params);
    }
    public sendByVue(vm: Vue, ...params) {
        this.send('anonymous', (vm as any)._uid, ...params);
    }

    public on(vm: Vue, name: string | number, proc: Function) {
        const watcher = () => {
            if (this.state.name === name) {
                proc(...this.state.params);
            }
        }
        delegate(vm, this.getters.notify, watcher);
    }

    public from(vm: Vue, proc: Function) {
        const watcher = () => {
            if (this.state.from === (vm as any)._uid) {
                proc(...this.state.params);
            }
        }
        delegate(vm, this.getters.notify, watcher);
    }

}

const broadcast = new BroadcastStore();

export { broadcast };